import {
  extend,
  groupedTranslations,
  setLocalizationConfigurations,
} from "@mongez/localization";
import {
  arValidationTranslation,
  enValidationTranslation,
} from "@mongez/react-form";
import { jsxConverter } from "@mongez/react-localization";
import { defaultLocaleCode } from "../environment";
import account from "./account.json";
import assessments from "./assessments.json";
import auth from "./auth.json";
import buyNow from "./buy-now.json";
import certificates from "./certificates.json";
import categoryDetails from "./category-details.json";
import challenge from "./challenge.json";
import checkout from "./checkout.json";
import common from "./common.json";
import communityGroups from "./community-groups.json";
import countries from "./countries.json";
import courses from "./courses.json";
import gamification from "./gamification.json";
import goldStore from "./gold-store.json";
import grades from "./grades.json";
import home from "./home.json";
import inquiries from "./inquiries.json";
import invoices from "./invoices.json";
import leaderboard from "./leaderboard.json";
import league from "./league.json";
import mobileApp from "./mobile-app.json";
import lessonCatalog from "./lesson-catalog.json";
import notifications from "./notifications.json";
import offers from "./offers.json";
import parentPortal from "./parent-portal.json";
import payment from "./payment.json";
import ratings from "./ratings.json";
import reports from "./reports.json";
import sessionHistory from "./session-history.json";
import myInvoices from "./my-invoices.json";
import shorts from "./shorts.json";
import socialHome from "./social-home.json";
import studentProfile from "./student-profile.json";
import subjectDetails from "./subject-details.json";
import trainingGround from "./training-ground.json";
import unlockCode from "./unlock-code.json";
import youtubePlayer from "./youtube-player.json";

const languages = ["en", "ar"];

export const supportedLanguages = [...languages];

export type Language = (typeof languages)[number];

export const returnLanguageIfSupported = (
  lang?: string,
): Language | undefined => {
  if (supportedLanguages.includes(lang as Language)) {
    return lang as Language;
  }
  return undefined;
};

setLocalizationConfigurations({
  converter: jsxConverter,
  defaultLocaleCode,
});

extend("en", { validation: enValidationTranslation });
extend("ar", { validation: arValidationTranslation });

groupedTranslations(common);
groupedTranslations("communityGroups", communityGroups);
groupedTranslations("countries", countries);
groupedTranslations("auth", auth);
groupedTranslations("checkout", checkout);
groupedTranslations("account", account);
groupedTranslations("buyNow", buyNow);
groupedTranslations("certificates", certificates);
groupedTranslations("categoryDetails", categoryDetails);
groupedTranslations("home", home);
groupedTranslations("assessments", assessments);
groupedTranslations("courses", courses);
groupedTranslations("grades", grades);
groupedTranslations("gamification", gamification);
groupedTranslations("goldStore", goldStore);
groupedTranslations("invoices", invoices);
groupedTranslations("leaderboard", leaderboard);
groupedTranslations("league", league);
groupedTranslations("lessonCatalog", lessonCatalog);
groupedTranslations("mobileApp", mobileApp);
groupedTranslations("inquiries", inquiries);
groupedTranslations("notifications", notifications);
groupedTranslations("offers", offers);
groupedTranslations("parentPortal", parentPortal);
groupedTranslations("unlockCode", unlockCode);
groupedTranslations("payment", payment);
groupedTranslations("ratings", ratings);
groupedTranslations("reports", reports);
groupedTranslations("challenge", challenge);
groupedTranslations("shorts", shorts);
groupedTranslations("socialHome", socialHome);
groupedTranslations("sessionHistory", sessionHistory);
groupedTranslations("myInvoices", myInvoices);
groupedTranslations("studentProfile", studentProfile);
groupedTranslations("trainingGround", trainingGround);
groupedTranslations("grades", subjectDetails);
groupedTranslations("youtubePlayer", youtubePlayer);
